module.exports = __webpack_public_path__ + "img/down-arrow.a520962e.png";